<template>
    <div class="employee-list-container">
        <div>
            <input id="filterEmployees" class="employee-filter full" v-model="filter" type="text"
                   placeholder="Mitarbeiter filtern" />
        </div>
        <div v-if="loading" style="width:100%; font-size:17px; line-height:300px; border: 1px solid darkgray;"
             class="text-center">
            <i class="fas fa-spinner"></i> Mitarbeiter werden aktualisiert
        </div>
        <div v-else class="employee-container">
            <div v-for="employee of filteredEmployees" :key="employee.id" class="content employee-item"
                 v-on:click="toggleSelection(employee.id)" v-bind:class="{selected : employee.isSelected}">
                <div class="employee-image">
                    <img v-if="employee.imageUrl" :src="employee.imageUrl"
                         :alt="`Image of ${employee.firstName} ${employee.lastName}`">
                    <i v-else class="fa fa-user-circle"></i>
                </div>
                <div class="employee-label">
                    {{ employee.lastName }} {{ employee.firstName }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'EmployeeList',
    props: {
        employees: Array,
        loading: Boolean,
        initAllSelected: {
            type: Boolean,
            default: () => true,
        },
        canSelectMultiple: {
            type: Boolean,
            default: () => true,
        },
        selectionColor: {
            type: String,
            default: () => 'var(--md)',
        },
    },
    data() {
        return {
            employeeList: this.mapEmployees(this.employees),
            filter: '',
        };
    },
    computed: {
        filteredEmployees() {
            const filter = this.filter.trim().toLowerCase();
            if (filter === '') return this.employeeList;
            return this.employeeList.filter(
                (employee) => employee.firstName.toLowerCase().includes(filter) || employee.lastName.toLowerCase().includes(filter),
            );
        },
    },
    watch: {
        employees: function(newVal) {
            this.employeeList = this.mapEmployees(newVal);
        },
    },
    methods: {
        mapEmployees(employees) {
            if (!employees)
                return [];
            return employees.map((employee) => ({
                isSelected: this.initAllSelected,
                ...employee,
            }));
        },
        toggleSelection(employeeId) {
            let employee = null;
            this.employeeList = this.employeeList.map(
                (emp) => {
                    if (emp.id === employeeId) {
                        employee = { ...emp, isSelected: !emp.isSelected };
                        return employee;
                    } else if (!this.canSelectMultiple) {
                        return { ...emp, isSelected: false };
                    }
                    return emp;
                },
            );
            this.$emit('employeeSelected', employee, this.employeeList.filter((emp) => emp.isSelected));
        },
    },
};
</script>

<style scoped>
.employee-list-container {
    height: calc(100vh - 250px);
    text-align: left;
    font-weight: bold;
    display: flex;
    flex-direction: column;
}

.employee-filter {
    border: 1px solid var(--contrast-3);
    border-bottom: none;
    background-color: var(--contrast-1), rgba(255, 255, 255, 0.5);
    color: var(--contrast-4);
    outline: none;
    box-shadow: none;
    border-radius: 0;
    transition: all 75ms linear;
}

.employee-filter:focus {
    background-color: var(--contrast-1), rgba(255, 255, 255, 0.25);
    color: var(--contrast-4);
    border: 1px solid var(--contrast-3);
    border-bottom-width: 0;
    box-shadow: none;
    outline: none;
}

.employee-filter::placeholder {
    color: var(--contrast-4);
    opacity: 0.5;
}

.employee-filter:hover::placeholder, .employee-filter:focus::placeholder {
    opacity: 0.9;
}

.employee-container {
    flex-grow: 1;
    border: 1px solid var(--contrast-3);
    overflow-y: scroll;
    overflow-x: hidden;
}

.employee-item {
    height: 2.5rem;
    margin: 0.25rem;
    width: calc(100% - 0.5rem);
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: var(--col-label-default);
    background: var(--contrast-1);
}

.selected {
    background: var(--md);
    color: var(--contrast-0);
}

.employee-container :hover {
    background: var(--col-ewb-box);
    color: var(--col-label-default);
}

.employee-image {
    border-radius: 1.75rem;
    overflow: hidden;
    margin: auto 0.5rem;
    width: 1.75rem;
    height: 1.75rem;
}

.employee-image > img {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
}

.employee-image > i {
    font-size: 1.75rem;
    opacity: 0.9;
}

.employee-label {
    text-align: left;
    font-size: 0.9rem;
    cursor: pointer;
}

.fas.fa-spinner {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(-45deg);
    }
    to {
        transform: rotate(315deg);
    }
}
</style>
